(function() {
    'use strict';

    let ticking = false;
    let scrollTimer = null;
    let animationFrameId = null;
    
    // Map to store animation state for each container
    const containerStates = new Map();
    
    // Get or create state for a container
    function getContainerState(container) {
        if (!containerStates.has(container)) {
            containerStates.set(container, {
                currentLeftX: -500,
                currentRightX: 600,
                targetLeftX: -500,
                targetRightX: 600
            });
        }
        return containerStates.get(container);
    }
    
    // Check if screen is desktop (>1199px)
    function isDesktop() {
        return window.innerWidth > 1199;
    }
    
    // Reset animation states for mobile/tablet
    function resetAnimationsForMobile() {
        const containers = document.querySelectorAll('.mod-brand-statement-banner');
        if (!containers) return;
        
        containers.forEach(container => {
            const leftElement = container.querySelector('.animation-scroll-left');
            const rightElement = container.querySelector('.animation-scroll-right');
            const rightColumn = container.querySelector('.mod-brand-statement-banner__right-column.is-show-animation');
        
        if (leftElement) {
            leftElement.style.transform = '';
            leftElement.style.transition = '';
        }
        if (rightElement) {
            rightElement.style.transform = '';
            rightElement.style.transition = '';
        }
        if (rightColumn) {
            rightColumn.style.transform = '';
            rightColumn.style.opacity = '';
            rightColumn.style.transition = '';
        }
    });
    }
    
    function updateAnimations() {
        // Only run animation on desktop (>1199px)
        if (!isDesktop()) {
            resetAnimationsForMobile();
            ticking = false;
            return;
        }
        
        const scrolled = window.pageYOffset;
        const windowHeight = window.innerHeight;
        
        // Get all containers and process each one
        const containers = document.querySelectorAll('.mod-brand-statement-banner');
        if (!containers.length) return;
        
        let needsAnimation = false;
        
        containers.forEach(container => {
            const state = getContainerState(container);
            const containerTop = container.offsetTop;
            const containerHeight = container.offsetHeight;
            
            // Calculate when animation should start and end
            // Animation starts when container is in the middle of the screen to see the whole process
            const animationStart = containerTop - (windowHeight / 1.5);
            // Animation completes when scrolled past container a bit
            const animationEnd = containerTop + (containerHeight / 8);
            
            // Don't animate if haven't scrolled close enough to element
            if (scrolled < animationStart) {
                // Keep elements in initial position (outside screen)
                const leftElement = container.querySelector('.animation-scroll-left');
                const rightElement = container.querySelector('.animation-scroll-right');
                const rightColumn = container.querySelector('.mod-brand-statement-banner__right-column.is-show-animation');
                
                if (leftElement) {
                    leftElement.style.transform = 'translateX(-500px)';
                }
                if (rightElement) {
                    rightElement.style.transform = 'translateX(600px)';
                }
                if (rightColumn) {
                    rightColumn.style.transform = 'translateY(80px)';
                    rightColumn.style.opacity = '0';
                }
                
                // Reset state to initial values
                state.currentLeftX = -500;
                state.currentRightX = 600;
                state.targetLeftX = -500;
                state.targetRightX = 600;
                return;
            }
            
            // Calculate scroll progress (0 to 1)
            let progress = 0;
            if (scrolled > animationStart) {
                progress = Math.min((scrolled - animationStart) / (animationEnd - animationStart), 1);
            }
            
            // Easing function for smoother animation
            const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
            const easedProgress = easeOutCubic(progress);
            
            // Calculate target positions
            const leftTranslate = -500 + (500 * easedProgress);
            // Increase delay for right text to see it more before it moves in
            const delayedProgress = Math.max(0, Math.min((easedProgress - 0.25) / 0.75, 1));
            const rightTranslate = 600 - (600 * delayedProgress);
            
            // Update target positions for this container
            state.targetLeftX = leftTranslate;
            state.targetRightX = rightTranslate;
            
            // Check if this container needs animation
            const threshold = 0.5;
            if (Math.abs(state.targetLeftX - state.currentLeftX) > threshold || 
                Math.abs(state.targetRightX - state.currentRightX) > threshold) {
                needsAnimation = true;
            }
            
            // Update right-column (fade in from bottom)
            const rightColumn = container.querySelector('.mod-brand-statement-banner__right-column.is-show-animation');
            if (rightColumn) {
                // Delay 20% so it starts after the text animations
                const columnProgress = Math.max(0, Math.min((easedProgress - 0.2) / 0.8, 1));
                const translateY = 80 - (80 * columnProgress); // Start 80px below
                const opacity = columnProgress;
                rightColumn.style.transform = `translateY(${translateY}px)`;
                rightColumn.style.opacity = opacity;
            }
        });
        
        // Start smooth animation if needed and not already running
        if (needsAnimation && !animationFrameId) {
            smoothAnimate();
        }
        
        // Clear previous timer
        clearTimeout(scrollTimer);
        
        // Set timer to re-enable transition after scroll stops
        scrollTimer = setTimeout(() => {
            containers.forEach(container => {
                const leftElement = container.querySelector('.animation-scroll-left');
                const rightElement = container.querySelector('.animation-scroll-right');
                const rightColumn = container.querySelector('.mod-brand-statement-banner__right-column.is-show-animation');
                
                if (leftElement) {
                    leftElement.style.transition = 'transform 0.3s ease-out';
                }
                if (rightElement) {
                    rightElement.style.transition = 'transform 0.3s ease-out';
                }
                if (rightColumn) {
                    rightColumn.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
                }
            });
        }, 100); // 100ms after scroll stops
        
        ticking = false;
    }
    
    function smoothAnimate() {
        // Only run animation on desktop (>1199px)
        if (!isDesktop()) {
            resetAnimationsForMobile();
            animationFrameId = null;
            return;
        }
        
        const containers = document.querySelectorAll('.mod-brand-statement-banner');
        if (!containers.length) {
            animationFrameId = null;
            return;
        }
        
        // Lerp factor (0.1 = slow, 0.3 = fast)
        const lerpFactor = 0.15;
        let needsContinuation = false;
        
        containers.forEach(container => {
            const state = getContainerState(container);
            
            // Smooth interpolation
            state.currentLeftX += (state.targetLeftX - state.currentLeftX) * lerpFactor;
            state.currentRightX += (state.targetRightX - state.currentRightX) * lerpFactor;
            
            // Update DOM elements
            const leftElement = container.querySelector('.animation-scroll-left');
            const rightElement = container.querySelector('.animation-scroll-right');
            
            if (leftElement) {
                leftElement.style.transition = 'none';
                leftElement.style.transform = `translateX(${state.currentLeftX}px)`;
            }
            
            if (rightElement) {
                rightElement.style.transition = 'none';
                rightElement.style.transform = `translateX(${state.currentRightX}px)`;
            }
            
            // Check if this container needs continuation
            const threshold = 0.5;
            if (Math.abs(state.targetLeftX - state.currentLeftX) > threshold || 
                Math.abs(state.targetRightX - state.currentRightX) > threshold) {
                needsContinuation = true;
            } else {
                // Snap to final position for this container
                if (leftElement) leftElement.style.transform = `translateX(${state.targetLeftX}px)`;
                if (rightElement) rightElement.style.transform = `translateX(${state.targetRightX}px)`;
            }
        });
        
        // Continue animation if any container needs it
        if (needsContinuation) {
            animationFrameId = requestAnimationFrame(smoothAnimate);
        } else {
            animationFrameId = null;
        }
    }
    
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateAnimations);
            ticking = true;
        }
    }
    
    // Event listeners
    window.addEventListener('scroll', requestTick);
    window.addEventListener('resize', function() {
        requestTick();
        // Reset animations when switching to mobile/tablet
        if (!isDesktop()) {
            resetAnimationsForMobile();
        }
    });
    
    // Initial call
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            if (isDesktop()) {
                updateAnimations();
            } else {
                resetAnimationsForMobile();
            }
        });
    } else {
        if (isDesktop()) {
            updateAnimations();
        } else {
            resetAnimationsForMobile();
        }
    }
})();

